const Flower = [
    {
      id: 1,
      image: "../Flower_photo/red_rose.jpg",
      name: "Red Rose",
      category: "Rose",
      price: "12₹",
      description:
        "I love Rose realy oo yues  Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
  
    {
      id: 2,
      image: "../Flower_photo/white_rose.jpg",
      name: "White Rose",
      category: "Rose",
      price: "20₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 3,
      image: "../Flower_photo/yollow_marigold.jpg",
      name: "Yollow Marigold",
      category: "Marigold",
      price: "10₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 4,
      image: "../Flower_photo/white_tuilip.jpg",
      name: "White Tulip",
      category: "Tulip",
      price: "50₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 5,
      image: "../Flower_photo/white_marigold.jpg",
      name: "White Marigold",
      category: "Marigold",
      price: "80₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 6,
      image: "../Flower_photo/red_tulip.jpg",
      name: "Red Tulip",
      category: "Tulip",
      price: "180₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 7,
      image: "../Flower_photo/red_marigold.jpg",
      name: "Red Marigold",
      category: "Marigold",
      price: "60₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 8,
      image: "../Flower_photo/red_lotus.jpg",
      name: "Red Lotus",
      category: "Lotus",
      price: "60₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
      id: 9,
      image: "../Flower_photo/purple_tulip.jpg",
      name: "Purple Tulip",
      category: "Tulip",
      price: "10₹",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
    },
    {
        id: 10,
        image: "../Flower_photo/purple_lotus.webp",
        name: "Purple Lotus",
        category: "Lotus",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 11,
        image: "../Flower_photo/pink_rose.jpg",
        name: "Pink Rose",
        category: "Rose",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 12,
        image: "../Flower_photo/pink_lotus.jpg",
        name: "Pink Lotus",
        category: "Lotus",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 13,
        image: "../Flower_photo/black_tuilip.jpg",
        name: "Black Tulip",
        category: "Tulip",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
      {
        id: 14,
        image: "../Flower_photo/black_rose.jpg",
        name: "Black Rose",
        category: "Rose",
        price: "10₹",
        description:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, at consectetur totam voluptatibus quibusdam iusto. Accusamus quas, soluta ipsam autem eius necessitatibus fugiat in . ",
      },
  ];
  
  export default Flower;